import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import ReactPaginate from 'react-paginate';

import '../../assets/css/style.css';
import '../../assets/css/costumer-landing-page.css';
import { URL } from '../../assets/js/constants';
import moedaBr from '../../assets/js/moedaBr';
import HeaderWebPage from '../businessLandingPage/HeaderWebPage';
import FooterWebPage from '../businessLandingPage/FooterWebPage';
import BackToTop from '../../components/templates/BackToTop';
import partnerLogoFallback from '../../assets/images/logo_tradicional_passarela_44.png';
import googlePlay from '../../assets/images/get_it_on_google_play_new.png';
import appStore from '../../assets/images/get_it_on_app_store_new.png';
import { CUSTOMER_HEADER_MENU_ITEMS } from '../shared/headerMenus';

const PROVAS_RAPIDAS = [
  { id: 'pr-1', valor: '+100', label: 'clientes atendidos' },
  { id: 'pr-2', valor: '5/5', label: 'avaliação média no app' },
  { id: 'pr-3', valor: 'Brasil todo', label: 'entrega com rastreio' },
  { id: 'pr-4', valor: 'Pagamento seguro', label: 'Pix e cartão protegido' },
];

const DEPOIMENTOS_CLIENTES = [
  {
    id: 'dc-1',
    nome: 'João, DF',
    texto: 'Comprei de duas lojas da 44 e chegou certinho. O app é simples, rápido e seguro.',
  },
  {
    id: 'dc-2',
    nome: 'Juliana, SP',
    texto: 'Achei peças lindas com preço ótimo. Baixei para testar e já virei cliente!',
  },
  {
    id: 'dc-3',
    nome: 'Larissa, GO',
    texto: 'Gostei da segurança no pagamento e do acompanhamento da entrega em tempo real.',
  },
];

const PAGE_SIZE = 8;
const IMAGEM_PLACEHOLDER = 'https://picsum.photos/seed/passarela44-placeholder/640/800';
const LOGOTIPO_PLACEHOLDER = partnerLogoFallback;

const formatarPreco = (value) => {
  const numero = Number(value || 0);
  return moedaBr(numero);
};

const obterImagemDoProduto = (produto) => {
  if (!produto) return '';

  if (produto.imagemPrincipal && typeof produto.imagemPrincipal === 'string') {
    return produto.imagemPrincipal;
  }

  if (produto.imagemPrincipal && produto.imagemPrincipal.url) {
    return produto.imagemPrincipal.url;
  }

  if (Array.isArray(produto.imagens) && produto.imagens.length > 0) {
    const imagemPrincipal = produto.imagens.find((img) => img.principal && img.url);
    if (imagemPrincipal) return imagemPrincipal.url;

    const primeiraImagemValida = produto.imagens.find((img) => img.url);
    if (primeiraImagemValida) return primeiraImagemValida.url;
  }

  if (produto.imagem && typeof produto.imagem === 'string') {
    return produto.imagem;
  }

  return IMAGEM_PLACEHOLDER;
};

const normalizarProduto = (produto, indice) => ({
  id: produto.id || `produto-${indice + 1}`,
  nome: produto.nome || 'Produto sem nome',
  preco: Number(produto.preco || 0),
  precoPromocional: Number(produto.precoPromocional || 0),
  estoque: Number(produto.estoque || 0),
  imagem: obterImagemDoProduto(produto),
  linkCompra: `/produto/${produto.id}`,
});

const normalizarListaProdutos = (lista = []) => {
  return lista
    .map((produto, indice) => normalizarProduto(produto, indice))
    .filter((produto) => produto.nome);
};

const handleImageFallback = (event) => {
  const { currentTarget } = event;
  if (currentTarget.src !== IMAGEM_PLACEHOLDER) {
    currentTarget.src = IMAGEM_PLACEHOLDER;
  }
};

const obterLogotipoDaLoja = (loja) => {
  if (!loja) return LOGOTIPO_PLACEHOLDER;

  if (typeof loja.logotipo === 'string' && loja.logotipo) {
    return loja.logotipo;
  }

  if (loja.logotipo && typeof loja.logotipo.url === 'string' && loja.logotipo.url) {
    return loja.logotipo.url;
  }

  if (typeof loja.logo === 'string' && loja.logo) {
    return loja.logo;
  }

  if (loja.logo && typeof loja.logo.url === 'string' && loja.logo.url) {
    return loja.logo.url;
  }

  if (typeof loja.imagem === 'string' && loja.imagem) {
    return loja.imagem;
  }

  return LOGOTIPO_PLACEHOLDER;
};

const handleLogoFallback = (event) => {
  const { currentTarget } = event;
  if (currentTarget.src !== LOGOTIPO_PLACEHOLDER) {
    currentTarget.src = LOGOTIPO_PLACEHOLDER;
  }
};

const isSpringPage = (data) => {
  return data && Array.isArray(data.content) && typeof data.totalPages === 'number';
};

const buscarProdutos = async (pageIndex = 0, pageSize = PAGE_SIZE) => {
  const endpointsPaginados = [
    `${URL}/produtos/page`,
  ];

  const params = {
    page: pageIndex,
    size: pageSize,
    linesPerPage: pageSize,
    direction: 'DESC',
    orderBy: 'id',
  };

  for (const endpoint of endpointsPaginados) {
    try {
      const resposta = await axios.get(endpoint, { params });
      if (isSpringPage(resposta.data)) {
        const pagina = resposta.data;
        const listaNormalizada = normalizarListaProdutos(pagina.content);

        return {
          produtos: listaNormalizada,
          page: typeof pagina.number === 'number' ? pagina.number : pageIndex,
          totalPages: typeof pagina.totalPages === 'number' ? pagina.totalPages : 1,
          totalElements: typeof pagina.totalElements === 'number' ? pagina.totalElements : listaNormalizada.length,
        };
      }
    } catch (_) {
      // Tenta o proximo endpoint paginado.
    }
  }

};

const buscarLojasParceiras = async () => {
  const endpoint = `${URL}/negocios/todos-negocios/MOBILE`;
  try {
    const resposta = await axios.get(endpoint);
    return resposta.data;
  } catch (_) {
    return [];
  }
};

const CostumerLandingPage = () => {
  const [produtos, setProdutos] = useState([]);
  const [lojasParceiras, setLojasParceiras] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const partnerMarqueeRef = useRef(null);
  const partnerTrackRef = useRef(null);
  const partnerManualModeRef = useRef(false);
  const partnerDragRef = useRef({
    isDragging: false,
    pointerId: null,
    startX: 0,
    startScrollLeft: 0,
  });

  useEffect(() => {
    let ativo = true;

    const carregar = async () => {
      setLoading(true);
      setError('');

      try {
        const dados = await buscarProdutos(page, PAGE_SIZE);

        if (!ativo) return;

        setProdutos(dados.produtos);
        setPage(dados.page);
        setTotalPages(dados.totalPages);
        setTotalElements(dados.totalElements);
      } catch (_) {
        if (!ativo) return;

        setError('Nao foi possivel carregar os produtos neste momento.');

        setProdutos([]);
        setPage(0);
        setTotalPages(1);
        setTotalElements(0);
      } finally {
        if (ativo) setLoading(false);
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [page]);

  useEffect(() => {
    const carregar = async () => {
      try {
        const lojas = await buscarLojasParceiras();
        setLojasParceiras(lojas);
      } catch (_) {
        setError('Nao foi possivel carregar as lojas parceiras neste momento.');
      }
    };

    carregar();
  }, []);

  const resumo = useMemo(() => {
    const comDesconto = produtos.filter((produto) => produto.precoPromocional > 0).length;
    const emEstoque = produtos.filter((produto) => produto.estoque > 0).length;

    return {
      total: totalElements,
      paginaAtual: produtos.length,
      comDesconto,
      emEstoque,
    };
  }, [produtos, totalElements]);

  const scrollToSection = (sectionId) => {
    const secao = document.getElementById(sectionId);
    if (secao) secao.scrollIntoView({ behavior: 'smooth' });
  };

  const handleComprar = (produto) => {
    if (produto.linkCompra) {
      window.open(produto.linkCompra, '_blank', 'noopener,noreferrer');
      return;
    }

    scrollToSection('baixar-app');
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setPage(selectedPage);
    scrollToSection('produtos');
  };

  const handlePartnerPointerDown = (event) => {
    const marquee = partnerMarqueeRef.current;
    const track = partnerTrackRef.current;
    if (!marquee) return;

    if (!partnerManualModeRef.current && track) {
      const trackStyle = window.getComputedStyle(track);
      const transformValue = trackStyle.transform;
      let translateX = 0;

      if (transformValue && transformValue !== 'none') {
        try {
          const matrix = new DOMMatrixReadOnly(transformValue);
          translateX = matrix.m41;
        } catch (_) {
          const matrixMatch = transformValue.match(/matrix\(([^)]+)\)/);
          if (matrixMatch) {
            const values = matrixMatch[1].split(',').map((value) => Number(value.trim()));
            if (values.length >= 6) {
              translateX = values[4];
            }
          }
        }
      }

      if (translateX < 0) {
        marquee.scrollLeft += Math.abs(translateX);
      }

      marquee.classList.add('is-manual-scroll');
      partnerManualModeRef.current = true;
    }

    partnerDragRef.current = {
      isDragging: true,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: marquee.scrollLeft,
    };

    if (marquee.setPointerCapture) {
      marquee.setPointerCapture(event.pointerId);
    }

    marquee.classList.add('is-dragging');
  };

  const handlePartnerPointerMove = (event) => {
    const marquee = partnerMarqueeRef.current;
    const dragState = partnerDragRef.current;

    if (!marquee || !dragState.isDragging || dragState.pointerId !== event.pointerId) return;

    event.preventDefault();

    const deltaX = event.clientX - dragState.startX;
    marquee.scrollLeft = dragState.startScrollLeft - deltaX;
  };

  const handlePartnerPointerRelease = (event) => {
    const marquee = partnerMarqueeRef.current;
    if (!marquee) return;

    const dragState = partnerDragRef.current;

    if (dragState.pointerId !== null && event.pointerId === dragState.pointerId && marquee.releasePointerCapture) {
      marquee.releasePointerCapture(event.pointerId);
    }

    partnerDragRef.current.isDragging = false;
    partnerDragRef.current.pointerId = null;
    marquee.classList.remove('is-dragging');
  };

  const resumePartnerAutoplay = () => {
    const marquee = partnerMarqueeRef.current;
    const track = partnerTrackRef.current;
    if (!marquee || !track || !partnerManualModeRef.current) return;

    const trackWidth = track.scrollWidth;
    const loopDistance = Math.max((trackWidth / 2) + 6, 1);
    const currentScroll = Math.max(0, marquee.scrollLeft);
    const normalizedScroll = currentScroll % loopDistance;
    const progress = normalizedScroll / loopDistance;

    const computedTrackStyle = window.getComputedStyle(track);
    const rawDuration = (computedTrackStyle.animationDuration || '24s').split(',')[0].trim();
    const durationSeconds = Number.parseFloat(rawDuration) || 24;

    track.style.animationDelay = `-${progress * durationSeconds}s`;
    marquee.scrollLeft = 0;
    marquee.classList.remove('is-manual-scroll');
    partnerManualModeRef.current = false;
  };

  const handlePartnerMouseLeave = () => {
    if (partnerDragRef.current.isDragging) return;
    resumePartnerAutoplay();
  };

  return (
    <>
      <div className="costumer-landing">
        <HeaderWebPage
          menuItems={CUSTOMER_HEADER_MENU_ITEMS}
          headerBgColor="#E2725B"
        />

        <main className="costumer-landing__container">
          <section id="hero" className="costumer-landing__hero" aria-label="Introducao da landing page do cliente">
            <div className="costumer-landing__hero-content">
              <div>
                <span className="costumer-landing__badge">Passarela 44 para clientes</span>
                <h1 className="costumer-landing__title">Compre da 44 com preços de fábrica e receba na sua casa.</h1>
                <p className="costumer-landing__subtitle">
                  Descubra tendências, ofertas e peças que cabem no seu estilo e no seu bolso.
                  Baixe o app, escolha seus looks favoritos e finalize com pagamento seguro em poucos minutos.
                </p>
                <div className="costumer-landing__hero-cta">
                  <button
                    type="button"
                    className="costumer-landing__button costumer-landing__button--primary"
                    onClick={() => scrollToSection('baixar-app')}
                  >
                    Baixar app e começar agora
                  </button>
                  <button
                    type="button"
                    className="costumer-landing__button costumer-landing__button--secondary"
                    onClick={() => scrollToSection('produtos')}
                  >
                    Ver vitrine
                  </button>
                </div>
                <div className="costumer-landing__hero-trust">
                  <span>Pagamento 100% seguro</span>
                  <span>Entrega para todo o Brasil</span>
                  <span>Ofertas novas toda semana</span>
                </div>
              </div>

              <aside className="costumer-landing__hero-card" aria-label="Resumo rapido da vitrine">
                <h3>Por que baixar agora</h3>
                <p>
                  Você encontra novidades da 44 em um só lugar, com preços atualizados, ofertas do dia e checkout rápido.
                </p>
                <div className="costumer-landing__stats">
                  <div className="costumer-landing__stat">
                    <strong>{resumo.total}</strong>
                    <span>itens na vitrine</span>
                  </div>
                  <div className="costumer-landing__stat">
                    <strong>{resumo.comDesconto}</strong>
                    <span>ofertas ativas</span>
                  </div>
                  <div className="costumer-landing__stat">
                    <strong>{resumo.emEstoque}</strong>
                    <span>prontos para envio</span>
                  </div>
                </div>
              </aside>

            </div>
          </section>

          <section className="costumer-landing__proof-strip" aria-label="Indicadores de confiança">
            {PROVAS_RAPIDAS.map((prova) => (
              <article key={prova.id} className="costumer-landing__proof-item">
                <strong>{prova.valor}</strong>
                <span>{prova.label}</span>
              </article>
            ))}
          </section>

          <section id="produtos" className="costumer-landing__products" aria-label="Lista de produtos">
            <div className="costumer-landing__products-header">
              <div>
                <span className="costumer-landing__section-kicker">Vitrine em tempo real</span>
                <h2>Produtos em destaque</h2>
                <p>Escolha seus favoritos agora e finalize a compra com segurança no aplicativo.</p>
              </div>
              <div className="costumer-landing__products-meta" aria-label="Resumo de produtos">
                <span>{resumo.total} itens</span>
                <span>{resumo.paginaAtual} nesta pagina</span>
                <span>{resumo.comDesconto} ofertas</span>
                <span>{resumo.emEstoque} disponíveis</span>
              </div>
            </div>

            {loading && <div className="costumer-landing__state">Carregando produtos...</div>}

            {!loading && error && <div className="costumer-landing__state">{error}</div>}

            {!loading && produtos.length > 0 && (
              <>
                <div className="costumer-landing__grid">
                  {produtos.map((produto) => {
                    const temPromocao = produto.precoPromocional > 0 && produto.precoPromocional < produto.preco;
                    const precoAtual = temPromocao ? produto.precoPromocional : produto.preco;

                    return (
                      <article key={produto.id} className="costumer-landing__card">
                        <div className="costumer-landing__image-box">
                          <img
                            src={produto.imagem}
                            alt={produto.nome}
                            loading="lazy"
                            decoding="async"
                            width="640"
                            height="800"
                            onError={handleImageFallback}
                            className="costumer-landing__image"
                          />
                          {temPromocao && <span className="costumer-landing__pill">Oferta</span>}
                        </div>

                        <div className="costumer-landing__card-body">
                          <h3 className="costumer-landing__name">{produto.nome}</h3>

                          <div className="costumer-landing__prices">
                            {temPromocao && <span className="costumer-landing__price--old">{formatarPreco(produto.preco)}</span>}
                            <span className="costumer-landing__price--current">{formatarPreco(precoAtual)}</span>
                          </div>

                          <p className="costumer-landing__stock">
                            {produto.estoque > 0 ? `Estoque: ${produto.estoque}` : 'Produto indisponível no momento'}
                          </p>

                          <button
                            type="button"
                            className="costumer-landing__buy"
                            disabled={produto.estoque <= 0}
                            onClick={() => handleComprar(produto)}
                          >
                            Comprar
                          </button>
                        </div>
                      </article>
                    );
                  })}
                </div>

                {totalPages > 1 && (
                  <ReactPaginate
                    previousLabel="<"
                    nextLabel=">"
                    breakLabel="..."
                    pageCount={totalPages}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={4}
                    onPageChange={handlePageClick}
                    forcePage={page}
                    renderOnZeroPageCount={null}
                    containerClassName="costumer-landing__pagination"
                    pageClassName="costumer-landing__pagination-item"
                    pageLinkClassName="costumer-landing__pagination-link"
                    previousClassName="costumer-landing__pagination-item"
                    previousLinkClassName="costumer-landing__pagination-link"
                    nextClassName="costumer-landing__pagination-item"
                    nextLinkClassName="costumer-landing__pagination-link"
                    breakClassName="costumer-landing__pagination-break"
                    breakLinkClassName="costumer-landing__pagination-link"
                    activeClassName="active"
                    disabledClassName="disabled"
                  />
                )}
              </>
            )}
          </section>

          <section className="costumer-landing__testimonials" aria-label="Depoimentos de clientes">
            <div className="costumer-landing__testimonials-header">
              <span className="costumer-landing__section-kicker">Clientes satisfeitos</span>
              <h2>Quem compra pelo app, volta a comprar</h2>
            </div>
            <div className="costumer-landing__testimonials-grid">
              {DEPOIMENTOS_CLIENTES.map((depoimento) => (
                <article key={depoimento.id} className="costumer-landing__testimonial-card">
                  <p>{depoimento.texto}</p>
                  <strong>{depoimento.nome}</strong>
                </article>
              ))}
            </div>
          </section>

          <section id="lojas-parceiras" className="costumer-landing__partners" aria-label="Lojas parceiras da Passarela 44">
            <div className="costumer-landing__partners-header">
              <span className="costumer-landing__section-kicker">Rede parceira</span>
              <h2>Lojas que já vendem com a gente</h2>
              <p>
                Conheça algumas marcas que movimentam a moda da 44 com a Passarela 44.
              </p>
            </div>

            <div
              ref={partnerMarqueeRef}
              className="costumer-landing__marquee"
              style={{ '--marquee-duration': `${Math.max(18, lojasParceiras.length * 2.8)}s` }}
              onPointerDown={handlePartnerPointerDown}
              onPointerMove={handlePartnerPointerMove}
              onPointerUp={handlePartnerPointerRelease}
              onPointerCancel={handlePartnerPointerRelease}
              onMouseLeave={handlePartnerMouseLeave}
            >
              <div ref={partnerTrackRef} className="costumer-landing__marquee-track" role="list" aria-label="Lista em movimento de lojas parceiras">
                {lojasParceiras.map((loja, index) => (
                  <article
                    key={`${loja.id}-${index}`}
                    className="costumer-landing__partner-card"
                    role="listitem"
                    aria-label={`${loja.nome}, ${loja.segmento}`}
                  >
                    <div className="costumer-landing__partner-card-top">
                      <div className="costumer-landing__partner-logo-box">
                        <img
                          src={obterLogotipoDaLoja(loja)}
                          alt={`Logotipo de ${loja.nome}`}
                          draggable={false}
                          loading="lazy"
                          decoding="async"
                          className="costumer-landing__partner-logo"
                          onError={handleLogoFallback}
                        />
                      </div>

                      <div className="costumer-landing__partner-copy">
                        <h3>{loja.nome}</h3>
                        <p>{loja.segmento}</p>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          <section id="baixar-app" className="costumer-landing__download" aria-label="Botoes para baixar o aplicativo">
            <div className="costumer-landing__download-content">
              <h2>Seu próximo look está a um toque de distância</h2>
              <p>
                Instale o app e compre direto das lojas da 44 com segurança, rastreio e novidades todos os dias.
              </p>
              <ul className="costumer-landing__download-benefits">
                <li>Ofertas reais com preços atualizados em tempo real</li>
                <li>Pagamento seguro com Pix e cartão</li>
                <li>Entrega para todo o Brasil com acompanhamento do pedido</li>
              </ul>
              <div className="costumer-landing__store-buttons">
                <a
                  href="https://apps.apple.com/br/app/passarela-44/id6758161244"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Baixar na App Store"
                >
                  <img src={appStore} alt="Baixar na App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.mobile.passarela44&pli=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Baixar no Google Play"
                >
                  <img src={googlePlay} alt="Baixar no Google Play" />
                </a>
              </div>
            </div>
          </section>
        </main>

        <FooterWebPage />
      </div>
      <BackToTop />
    </>
  );
};

export default CostumerLandingPage;
